const libPictView = require('pict-view');

const _ViewConfiguration = require('./panes/HeadlightPanels-Pane-View-Templates.json')['HeadlightPanels-Pane-ProfilePaneHtml-View'];

class HeadlightPaneProfile extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		const tmpOptions = Object.assign({}, _ViewConfiguration, pOptions);
		super(pFable, tmpOptions, pServiceHash);
	}

	navigateToProfileApp(event)
	{
		const hostParts = document.location.host.split('.');
		hostParts.shift(); // remove current application
		hostParts.unshift('profile');
		const profileURL = '//' + hostParts.join('.');
		window.open(profileURL, '_blank');
	}
}

module.exports = HeadlightPaneProfile;

module.exports.default_configuration = _ViewConfiguration;
